import React, { Component } from 'react';
import gsap from 'gsap'

import { getRandom } from '../../../utils/numbers.js'

class Star extends Component {


    constructor(props) {

        super(props)

        this.state = {
            hasStarted: false
        }

        this.start = this.start.bind(this)
        this.stop = this.stop.bind(this)

    }

    componentDidMount() {

        this.start()

    }

    start() {

        const { viewport, delay, speed } = this.props

        this.tl = gsap.timeline()

        this.tl.to(this.el, {
            duration: speed,
            left: viewport.width + 20,
            top: getRandom(0, viewport.height),
            delay: delay,
            repeat: -1,
            yoyo: false,
            ease: 'none',
            rotationY: 1000,
            rotationX: 1000
        })

        this.setState({
            hasStarted: true
        })

    }

    stop() {
        
        if (typeof this.tl !== 'undefined') {
            this.tl.kill()
        }

    }

    componentWillUnmount() {
        this.stop()
    }




    render() {

        const { left, top, width, r, g, b } = this.props

        const starStyle = {
            top,
            left,
            width,
            background: `rgb(${r},${g},${b})`
        }

        return (
            <div className="star" ref={(el) => { this.el = el }} style={starStyle}></div>
        );
    }
}

export default Star;
